import {
  HTTP_GETBUDGETCOMPSBYDEPT_FETCHING,
  HTTP_GETBUDGETCOMPSBYDEPT_SUCCESS,
  HTTP_GETBUDGETCOMPSBYDEPT_FAILED,
  server,
  OK,
  YES,
} from "src/Constants";
import { httpClient } from "src/utils/HttpClient";

export const setStateBudgetCompSDToFetching = () => ({
  type: HTTP_GETBUDGETCOMPSBYDEPT_FETCHING,
});

export const setStateBudgetCompSDToSuccess = (payload) => ({
  type: HTTP_GETBUDGETCOMPSBYDEPT_SUCCESS,
  payload,
});

export const setStateBudgetCompSDToFailed = (payload) => ({
  type: HTTP_GETBUDGETCOMPSBYDEPT_FAILED,
});

export const clearBudgetCompSD = () => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompSDToSuccess([]));
  };
};

export const getBudgetCompSD = (country, company, brand, year, item) => {
  return async (dispatch) => {
    dispatch(setStateBudgetCompSDToFetching());
    try {
      const result = await httpClient.put(
        `${server.GETBUDGETCOMPBYDEPTS_URL}/${country}/${company}/${brand}/${year}`,
        item,
        {
          headers: {
            authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      dispatch(setStateBudgetCompSDToSuccess(result.data));
      return Promise.resolve(result.data[0]);
    } catch (error) {
      dispatch(setStateBudgetCompSDToFailed());
    }
  };
};
